(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lf-new-arrivals')) {
  customElements.define('lf-new-arrivals', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.events = null;
      this.resize?.disconnect();
      this.visibility?.disconnect();
      clearTimeout(this.timer);
      clearTimeout(this.rangeTimer);
    }
    setup() {
      const track = this.querySelector('[data-hero-products-track]');
      if (!track || this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      const cards = [...track.querySelectorAll('.lf-product-card')];
      const previous = this.querySelector('[data-hero-products-left]');
      const next = this.querySelector('[data-hero-products-right]');
      const range = this.querySelector('[data-new-in-range]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let pointer = null;
      let dragged = false;
      const sign = () => getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      const max = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const position = () => Math.abs(track.scrollLeft);
      const step = () => cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
      const go = value => track.scrollTo({ left: sign() * Math.max(0, Math.min(max(), value)), behavior: motion.matches ? 'instant' : 'smooth' });
      const update = () => {
        previous.disabled = position() < 4;
        next.disabled = position() >= max() - 4;
        clearTimeout(this.rangeTimer);
        this.rangeTimer = setTimeout(() => {
          const bounds = track.getBoundingClientRect();
          const shown = cards.map((card, index) => ({ box: card.getBoundingClientRect(), index }))
            .filter(({ box }) => Math.min(box.right, bounds.right) - Math.max(box.left, bounds.left) > box.width / 2);
          if (shown.length) range.textContent = range.dataset.template.replace('__FIRST__', shown[0].index + 1).replace('__LAST__', shown.at(-1).index + 1);
        }, 120);
      };
      const stop = () => clearTimeout(this.timer);
      const schedule = () => {
        stop();
        if (this.dataset.heroProductsAutoplay !== 'true' || motion.matches || !visible || document.hidden || pointer || this.matches(':hover') || this.contains(document.activeElement) || max() < 4) return;
        this.timer = setTimeout(() => {
          go(position() >= max() - 4 ? 0 : position() + step());
          schedule();
        }, Number(this.dataset.heroProductsAutoplayDelay) || 4000);
      };
      const move = direction => {
        stop();
        go(position() + direction * Math.max(1, Math.floor((track.clientWidth + (parseFloat(getComputedStyle(track).gap) || 0)) / step())) * step());
        schedule();
      };
      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      track.addEventListener('scroll', update, { passive: true, signal });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move((event.key === 'ArrowRight' ? 1 : -1) * sign());
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          go(event.key === 'Home' ? 0 : max());
        }
      }, { signal });
      track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      track.addEventListener('pointerdown', event => {
        stop();
        dragged = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button,.lf-home-quick-add')) return;
        pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft };
      }, { signal });
      track.addEventListener('pointermove', event => {
        if (!pointer || pointer.id !== event.pointerId) return;
        const dx = event.clientX - pointer.x;
        if (!dragged && (Math.abs(dx) < 7 || Math.abs(dx) < Math.abs(event.clientY - pointer.y))) return;
        dragged = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
        track.scrollLeft = pointer.left - dx;
        event.preventDefault();
      }, { signal });
      const release = event => {
        if (pointer && event.pointerId === pointer.id) {
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
          pointer = null;
          track.classList.remove('is-dragging');
        }
        schedule();
      };
      window.addEventListener('pointerup', release, { signal });
      window.addEventListener('pointercancel', release, { signal });
      track.addEventListener('click', event => {
        if (!dragged) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        dragged = false;
      }, { capture: true, signal });
      this.addEventListener('mouseenter', stop, { signal });
      this.addEventListener('mouseleave', schedule, { signal });
      this.addEventListener('focusin', stop, { signal });
      this.addEventListener('focusout', () => setTimeout(schedule, 0), { signal });
      document.addEventListener('visibilitychange', schedule, { signal });
      motion.addEventListener('change', schedule, { signal });
      this.resize = new ResizeObserver(() => { update(); schedule(); });
      this.resize.observe(track);
      this.visibility = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
      this.visibility.observe(this);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-reviews"] && !Shopify.designMode) return;
  try {
    
  function filterProductReviewsToFiveStars() {
    document.querySelectorAll('.lf-reviews[data-lf-product-five-star]').forEach(section => {
      if (section.lfFiveStarObserver) return;
      const applyFilter = () => {
        const outer = section.querySelector('#judgeme_product_reviews');
        const widget = section.querySelector('.jdgm-rev-widg');
        const fiveStar = section.querySelector('.jdgm-histogram__row[data-rating="5"]');
        if (!outer?.classList.contains('jdgm--done-setup-widget') || !widget || !fiveStar) return false;
        const count = Number(fiveStar.dataset.frequency);
        if (!Number.isFinite(count) || count < 1) {
          section.dataset.lfFiveStarReady = 'false';
          return true;
        }
        // Keep Judge.me's own pagination and sort requests scoped to five-star reviews.
        if (!fiveStar.classList.contains('jdgm-histogram__row--selected')) fiveStar.click();
        const heading = widget.querySelector('.jdgm-rev-widg__title');
        if (heading && heading.textContent !== section.dataset.lfFiveStarHeading) {
          heading.textContent = section.dataset.lfFiveStarHeading;
        }
        section.dataset.lfMixedRatings = String(Number(widget.dataset.averageRating) < 5);
        section.dataset.lfFiveStarReady = 'true';
        return true;
      };
      let queued = false;
      section.lfFiveStarObserver = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; applyFilter(); });
      });
      section.lfFiveStarObserver.observe(section, { childList: true, subtree: true });
      let attempts = 0;
      const timer = window.setInterval(() => {
        if (!section.isConnected || applyFilter() || ++attempts > 100) window.clearInterval(timer);
      }, 200);
      applyFilter();
      section.addEventListener('shopify:section:unload', () => {
        window.clearInterval(timer);
        section.lfFiveStarObserver.disconnect();
      }, { once: true });
    });
  }
  filterProductReviewsToFiveStars();
  document.addEventListener('shopify:section:load', filterProductReviewsToFiveStars);

  // Judge.me's media script waits only one second for its carousel utilities.
  // If that race expires, reload that same official asset once after its dependencies exist.
  function recoverReviewCarousel() {
    if (!document.querySelector('.lf-reviews .jdgm-cards-carousel')) return;
    let attempts = 0;
    const timer = window.setInterval(() => {
      if (window.jdgmBuildMediaCards || ++attempts > 80) {
        window.clearInterval(timer);
        return;
      }
      if (!window.jdgmCarouselUtils || !window.jdgmCarouselMode) return;
      const source = Object.keys(window.jdgmCarouselScripts || {}).find(url =>
        url.startsWith('https://cdn.shopify.com/extensions/') && url.endsWith('/media_carousel.js')
      );
      if (!source) return;
      window.clearInterval(timer);
      if (document.querySelector('script[data-lf-review-carousel-retry]')) return;
      const script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.dataset.lfReviewCarouselRetry = 'true';
      document.head.appendChild(script);
    }, 250);
  }
  recoverReviewCarousel();
  document.addEventListener('shopify:section:load', recoverReviewCarousel);

  function restoreShopReviewPhotos() {
    document.querySelectorAll('.lf-reviews[data-lf-shop-review-media]').forEach(section => {
      if (section.lfShopPhotoObserver) return;
      let photos;
      try { photos = JSON.parse(section.dataset.lfShopReviewMedia); } catch { return; }
      if (!photos || typeof photos !== 'object') return;
      const sources = Object.fromEntries(Object.entries(photos).map(([id, urls]) => [id,
        Array.isArray(urls) ? urls.filter(source => {
          try {
            const url = new URL(source);
            return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' &&
              url.pathname.startsWith('/b/shop-server-review-media-production/');
          } catch { return false; }
        }) : []
      ]));
      const applyPhotos = () => {
        const carousel = section.querySelector('.jdgm-cards-carousel');
        const state = window.jdgmCarouselMode?.[carousel?.dataset.jdgmBlockId];
        if (!state?.reviews?.length) return;
        carousel.querySelectorAll('.jdgm-card .jdgm-text').forEach(text => {
          // The native card hides later paragraphs; build one excerpt without changing review data.
          const paragraphs = Array.from(text.querySelectorAll(':scope > p'));
          if (paragraphs.length > 1) {
            paragraphs[0].textContent = paragraphs.map(p => p.textContent.trim()).filter(Boolean).join(' ');
            paragraphs.slice(1).forEach(p => p.remove());
          }
          if (text.querySelector('.lf-review-read-more')) return;
          const hint = document.createElement('button');
          hint.type = 'button';
          hint.className = 'lf-review-read-more';
          hint.textContent = 'Read full review';
          text.append(hint);
        });
        let restored = 0;
        state.reviews.forEach(review => {
          const urls = sources[review.uuid];
          if (Number(review.rating) !== 5 || !urls?.length) return;
          if (!review.pictures_urls?.length) {
            review.pictures_urls = urls.map(source => ({ original: source, huge: source, mobile: source, small: source, compact: source }));
            review.picture = { urls: review.pictures_urls[0] };
            review.card_type = 'photo';
          }
          carousel.querySelectorAll('[data-review-id]').forEach(card => {
            if (card.dataset.reviewId !== review.uuid || card.querySelector('img')) return;
            const image = document.createElement('img');
            image.src = urls[0];
            image.alt = review.reviewer_name || '';
            image.loading = 'lazy';
            image.decoding = 'async';
            image.width = 400;
            image.height = 400;
            card.classList.remove('jdgm-text-card');
            card.prepend(image);
          });
          restored++;
        });
        section.dataset.lfShopPhotosReady = String(restored);
      };
      let queued = false;
      const queueApply = () => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; applyPhotos(); });
      };
      section.lfShopPhotoObserver = new MutationObserver(queueApply);
      section.lfShopPhotoObserver.observe(section, { childList: true, subtree: true });
      let attempts = 0;
      const timer = window.setInterval(() => {
        if (!section.isConnected || ++attempts > 200) { window.clearInterval(timer); return; }
        applyPhotos();
        if (section.dataset.lfShopPhotosReady === String(Object.values(sources).filter(urls => urls.length).length)) {
          window.clearInterval(timer);
        }
      }, 100);
      applyPhotos();
      section.addEventListener('shopify:section:unload', () => {
        window.clearInterval(timer);
        section.lfShopPhotoObserver.disconnect();
      }, { once: true });
    });
  }
  restoreShopReviewPhotos();
  document.addEventListener('shopify:section:load', restoreShopReviewPhotos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lolita-petticoat-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  function calculate({drop, trim, gapMin, gapMax, full}) {
    if (![drop, gapMin, gapMax].every(Number.isFinite) || drop <= 0) return {error: 'required'};
    if (gapMin < 0 || gapMax < 0 || gapMin > gapMax) return {error: 'gaps'};
    if (drop > 200 || gapMax > 30) return {error: 'bounds'};
    const deduction = full ? trim : 0;
    if (!Number.isFinite(deduction) || deduction < 0 || deduction >= drop) return {error: 'trim'};
    const opaque = drop - deduction;
    if (opaque <= gapMax) return {error: 'short'};
    return {low: opaque - gapMax, high: opaque - gapMin, deduction};
  }
  function selectionNotes({shape, use, concern}) {
    const safeShape = ['aline', 'bell'].includes(shape) ? shape : 'unsure';
    const safeUse = ['seated', 'fullness'].includes(use) ? use : 'daily';
    const safeConcern = ['heavy', 'sheer', 'waist'].includes(concern) ? concern : 'none';
    return [`choice_shape_${safeShape}`, `choice_use_${safeUse}`, `choice_concern_${safeConcern}`];
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {calculate, selectionNotes};
  if (typeof window === 'undefined' || customElements.get('lf-petticoat-guide')) return;
  class PetticoatGuide extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      if (!this.querySelector('[data-pg-data]')) {
        this.observer = new MutationObserver(() => { if(this.querySelector('[data-pg-messages]')) { this.observer.disconnect(); this.connectedCallback(); } });
        this.observer.observe(this, {childList:true, subtree:true});
        return;
      }
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-pg-data]').textContent);
      this.messages = JSON.parse(this.querySelector('[data-pg-messages]').textContent);
      this.unit = 'cm'; this.filter = 'all'; this.lengthFilter = null; this.result = null; this.isExample = false;
      this.values = {drop:null, trim:0, gapMin:3, gapMax:5};
      this.inputs = [...this.querySelectorAll('[data-dimension]')];
      this.form = this.querySelector('[data-fit-form]');
      this.form.addEventListener('submit', e => {e.preventDefault(); this.run(true);});
      this.inputs.forEach(input => input.addEventListener('input', () => {
        const raw = input.value.trim();
        this.values[input.dataset.dimension] = raw === '' ? null : Number(raw) * (this.unit === 'in' ? 2.54 : 1);
        this.isExample = false;
        this.invalidate();
      }));
      this.querySelector('[data-unit]').addEventListener('change', e => {
        this.unit = e.target.value;
        this.inputs.forEach(input => {
          const value = this.values[input.dataset.dimension];
          input.value = value === null ? '' : this.number(value / this.factor(), 2);
        });
        this.querySelector('[data-dimension="drop"]').placeholder = this.unit === 'cm' ? '55' : '21.65';
        this.querySelectorAll('[data-unit-label]').forEach(x => x.textContent = this.unit);
        if (this.result) this.paintResult();
      });
      this.querySelectorAll('[name="pg-endpoint"]').forEach(input => input.addEventListener('change', () => {
        this.querySelector('[data-trim-field]').hidden = !this.fullHem();
        this.isExample = false; this.invalidate();
      }));
      this.querySelector('[data-example]').addEventListener('click', () => {
        this.values = {drop:55, trim:0, gapMin:3, gapMax:5}; this.unit = 'cm'; this.isExample = true;
        this.querySelector('[data-unit]').value = 'cm';
        this.inputs.forEach(input => input.value = this.values[input.dataset.dimension]);
        this.querySelectorAll('[data-unit-label]').forEach(x => x.textContent = 'cm');
        this.querySelector('[value="opaque"]').checked = true;
        this.querySelector('[data-trim-field]').hidden = true;
        this.run(false);
      });
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        this.filter = button.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach(x => x.setAttribute('aria-pressed', String(x === button)));
        this.applyFilters();
      }));
      this.querySelector('[data-compare-estimate]').addEventListener('click', () => {
        if(!this.result) return;
        this.lengthFilter = {low:this.result.low, high:this.result.high}; this.applyFilters();
        this.querySelector('#comparison').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      this.querySelector('[data-clear-range]').addEventListener('click', () => {this.lengthFilter = null;this.applyFilters();});
      this.querySelectorAll('[data-download]').forEach(button => button.addEventListener('click', () => this.download(button.dataset.download)));
      const choiceForm = this.querySelector('[data-choice-form]');
      choiceForm?.addEventListener('submit', event => {
        event.preventDefault();
        const values = Object.fromEntries(new FormData(choiceForm));
        const list = this.querySelector('[data-choice-notes]');
        list.replaceChildren(...selectionNotes(values).map(key => {
          const item = document.createElement('li'); item.textContent = this.t(key); return item;
        }));
        this.querySelector('[data-choice-result]').hidden = false;
      });
      choiceForm?.addEventListener('change', () => { this.querySelector('[data-choice-result]').hidden = true; });
      this.revealAnchor();
      this.hashHandler = () => this.revealAnchor();
      window.addEventListener('hashchange', this.hashHandler);
    }
    disconnectedCallback() { this.observer?.disconnect(); if(this.hashHandler) window.removeEventListener('hashchange', this.hashHandler); }
    t(key, args = {}) { return Object.entries(args).reduce((s,[k,v]) => s.replaceAll(`{${k}}`, v), this.messages[key] || key); }
    factor() { return this.unit === 'in' ? 2.54 : 1; }
    number(n, places = 1) { return Number(n.toFixed(places)).toString(); }
    fullHem() { return this.querySelector('[name="pg-endpoint"]:checked').value === 'full'; }
    invalidate() {
      this.result = null;
      this.querySelector('[data-result]').hidden = true;
      this.querySelector('[data-empty]').hidden = false;
      this.querySelector('[data-error]').hidden = true;
      if(this.lengthFilter) {this.lengthFilter = null;this.applyFilters();}
    }
    run(focusError) {
      const result = calculate({...this.values, full:this.fullHem()});
      const error = this.querySelector('[data-error]');
      if(result.error) {
        this.invalidate(); error.textContent = this.t(result.error); error.hidden = false;
        if(focusError) {error.setAttribute('tabindex', '-1'); error.focus();}
        return;
      }
      error.hidden = true; this.result = result;
      if(this.lengthFilter) {this.lengthFilter = {low:result.low,high:result.high};this.applyFilters();}
      this.paintResult();
    }
    paintResult() {
      const f = this.factor(); const r = this.result;
      const v = {drop:this.number(this.values.drop/f), trim:this.number(r.deduction/f), min:this.number(this.values.gapMin/f), max:this.number(this.values.gapMax/f), low:this.number(r.low/f), high:this.number(r.high/f), unit:this.unit};
      this.querySelector('[data-empty]').hidden = true; this.querySelector('[data-result]').hidden = false;
      this.querySelector('[data-range]').textContent = `${v.low}–${v.high}`;
      this.querySelector('[data-result-unit]').textContent = this.unit;
      this.querySelector('[data-result-label]').textContent = this.t(this.isExample ? 'example' : 'result');
      this.querySelector('[data-equation]').textContent = this.t('equation', v);
      this.querySelector('[data-input-summary]').textContent = this.t('summary', v);
    }
    applyFilters() {
      let count = 0;
      this.data.models.forEach(model => {
        const row = this.querySelector(`#spec-${model.id}`);
        const matchType = this.filter === 'all' || model.construction === this.filter;
        const matchLength = !this.lengthFilter || model.variants.some(v => v.length_cm >= this.lengthFilter.low - 1e-8 && v.length_cm <= this.lengthFilter.high + 1e-8);
        row.hidden = !(matchType && matchLength); if(!row.hidden) count++;
        const matching = row.querySelector('[data-matching-lengths]');
        matching.hidden = !this.lengthFilter;
        if(this.lengthFilter) matching.textContent = this.t('matching', {lengths:[...new Set(model.variants.filter(v=>v.length_cm>=this.lengthFilter.low-1e-8 && v.length_cm<=this.lengthFilter.high+1e-8).map(v=>v.length_cm))].join(' / ')});
      });
      this.querySelector('[data-filter-summary]').textContent = this.t('count', {count});
      this.querySelector('[data-no-matches]').hidden = count > 0;
      this.querySelector('[data-range-filter]').hidden = !this.lengthFilter;
      if(this.lengthFilter) this.querySelector('[data-range-label]').textContent = this.t('length_filter',{low:this.number(this.lengthFilter.low),high:this.number(this.lengthFilter.high)});
    }
    revealAnchor() {
      let id; try{id=decodeURIComponent(location.hash.slice(1));}catch{return;}
      if(!id.startsWith('spec-')) return;
      const row = [...this.querySelectorAll('tr[id]')].find(x => x.id === id); if(!row) return;
      this.filter = 'all';this.lengthFilter = null;this.applyFilters();
      this.querySelectorAll('[data-filter]').forEach(x => x.setAttribute('aria-pressed',String(x.dataset.filter === 'all')));
      row.querySelector('details').open = true;
      requestAnimationFrame(() => row.scrollIntoView({block:'center'}));
    }
    download(type) {
      const headers = ['record_id','brand','model','variant','data_type','source_url','source_checked_on','measured_on','listed_length_cm','listed_waist_text','listed_material','listed_layers','measured_length_front_cm','measured_length_side_cm','measured_length_back_cm','resting_waist_cm','stretch_waist_cm','stretch_force_n','stretch_method','sample_mass_g','scale_resolution_g','support_layers_counted','lining_layers_counted','material_label','measurer','sample_condition','notes'];
      const rows = type === 'specs' ? this.data.models.flatMap(m => m.variants.map((v,i) => [m.id+'-'+(i+1),m.brand,m.name,v.version,'retailer_listing',m.url,this.data.checked_on,'',v.length_cm,v.waist_label,m.material,m.layers??'','','','','','','','','','','','','','','',m.notes])) : Array.from({length:12},(_,i) => [String(i+1).padStart(2,'0'),'','','','planned_not_measured',...Array(22).fill('')]);
      const csvCell = value => '"' + String(value ?? '').replace(/^[=+@\-]/,'\'$&').replaceAll('"','""') + '"';
      const csv = '\uFEFF' + [headers,...rows].map(row => row.map(csvCell).join(',')).join('\r\n') + '\r\n';
      try {
        const blob = new Blob([csv], {type:'text/csv;charset=utf-8;'}); const url = URL.createObjectURL(blob);
        const a = document.createElement('a');a.href=url;a.download = type === 'specs' ? `lolitafetch-petticoat-specifications-${this.data.checked_on}.csv` : 'lolitafetch-petticoat-measurement-worksheet.csv';
        document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
      } catch {const e=this.querySelector('[data-error]');e.textContent=this.t('download_error');e.hidden=false;e.scrollIntoView();}
    }
  }
  customElements.define('lf-petticoat-guide', PetticoatGuide);
})();


  } catch(e) { console.error(e); }
})();
})();
